// components/ChannelTalkBoot.tsx
import { useEffect, useRef } from "react";
import ChannelService from "./channel-talk";

declare global {
  interface Window {
    channelBooted?: boolean;
  }
}

const PLUGIN_KEY = process.env.REACT_APP_CHANNEL_IO_PLUGIN_KEY || "";

const ChannelTalkBoot: React.FC = () => {
  const bootedRef = useRef(false);

  useEffect(() => {
    ChannelService.loadScript();

    const cleanup = () => {
      ChannelService.clearCallbacks();
    };

    if (!PLUGIN_KEY) {
      console.error("[ChannelTalk] Missing REACT_APP_CHANNEL_IO_PLUGIN_KEY");
      return cleanup; // consistent return
    }

    if (!bootedRef.current && !window.channelBooted) {
      ChannelService.boot(
        {
          pluginKey: PLUGIN_KEY,
          hideChannelButtonOnBoot: true,
          language: "ko",
          trackDefaultEvent: true,
          trackUtmSource: true,
        },
        (err: unknown) => {
          if (err) console.error("[ChannelTalk] boot error:", err);
        },
      );
      bootedRef.current = true;
      window.channelBooted = true;
    }

    return cleanup;
  }, []);

  return null;
};

export default ChannelTalkBoot;
